import * as actionTypes from "../../actions/actionTypes";

const initialState = {
    testData: [],
    completedTestData: [],
    testQuestions: [],
    loadingTestData: false,
    loadingCompletedTestData: false,
    loadingTestQuestions: false
};

const loadTestData = (state) => {
    return {
        ...state,
        loadingTestData: true
    }
}

const setTestData = (state, action) => {
    let tmp = {...action.testData}
    return {
        ...state,
        testData: tmp,
        loadingTestData: false
    }
};

const loadCompletedTestData = (state) => {
    return {
        ...state,
        loadingCompletedTestData: true
    }
}

const setCompletedTestData = (state, action) => {
    let tmp = {...action.completedTestData}
    return {
        ...state,
        completedTestData: tmp,
        loadingCompletedTestData: false
    }
};

const loadTestQuestions = (state) => {
    return {
        ...state,
        loadingTestQuestions: true
    }
}

const setTestQuestions = (state, action) => {
    let tmp = {...action.testQuestions}
    return {
        ...state,
        testQuestions: tmp,
        loadingTestQuestions: false
    }
};

const loadSubmitTest = (state) => {
    return {
        ...state,
        loadingSubmitTest: true
    }
}

const setSubmitTest = (state, action) => {
    let tmp = {...action.correctAnswers}
    return {
        ...state,
        correctAnswers: tmp,
        loadingSubmitTest: false
    }
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_TEST_DATA:
            return loadTestData(state);
        case actionTypes.SET_TEST_DATA:
            return setTestData(state, action);
        case actionTypes.LOAD_COMPLETED_TEST_DATA:
            return loadCompletedTestData(state);
        case actionTypes.SET_COMPLETED_TEST_DATA:
            return setCompletedTestData(state, action);
        case actionTypes.LOAD_TEST_QUESTIONS:
            return loadTestQuestions(state);
        case actionTypes.SET_TEST_QUESTIONS:
            return setTestQuestions(state, action);
        case actionTypes.LOAD_SUBMIT_TEST:
            return loadSubmitTest(state);
        case actionTypes.SET_SUBMIT_TEST:
            return setSubmitTest(state, action);
        default:
            return state;
    }
};
export default reducer;
